import React, { useCallback } from "react";
import { SingleAddress } from "./single-address";
import TranslateManager from 'ts-translate-js';
import { Address } from "../../../types/models/mvcapi";
import './address-panel.scss';

const tr = TranslateManager.boundTR;

type AddressPanelProps = {
    billingAddress: Address;
    addressErrors: any;
    audtoEditMode?: boolean;
    onChange: (billingAddress: Address) => void;
};

export function AddressPanel({billingAddress, addressErrors, audtoEditMode=false, onChange}: AddressPanelProps) {

    const handleOnRemoveBillingAddress = useCallback(() => {
        onChange(null);
    }, [onChange]);

    const handleOnConfirmBillingAddress = useCallback((editedAddress: Address) => {
        onChange(editedAddress);
    }, [onChange]);

    return <div className="address-panel">
        <SingleAddress
            address={billingAddress}
            addressType={tr("Vos coordonnées")}
            allowRemove={false}
            addressErrors={addressErrors}
            audtoEditMode={audtoEditMode}
            onRemoveAddress={handleOnRemoveBillingAddress}
            onConfirm={handleOnConfirmBillingAddress}
        />
    </div>;
}